import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { Dialog } from '@headlessui/react';
import { useSpring, animated } from '@react-spring/web';
import { useEffect } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var AnimatedModal = animated(Dialog);
export function ModalLayout(_ref) {
  var isOpen = _ref.isOpen,
      children = _ref.children,
      styles = _ref.styles,
      onClose = _ref.onClose;
  var animation = useSpring({
    opacity: isOpen ? 1 : 0,
    transform: isOpen ? "translateY(0)" : "translateY(-200%)"
  });
  useEffect(function () {
    // 👇 add class to body element
    if (isOpen) {
      document.body.classList.add('dialog-open');
    } else {
      document.body.classList.remove('dialog-open');
    }
  }, [isOpen]);
  var modalWidth = 'fit-content';
  var modalHeight = 'fit-content';
  return /*#__PURE__*/_jsx(StyledAnimatedModalContainer, {
    children: /*#__PURE__*/_jsxs(StyledAnimatedModal, {
      open: isOpen,
      onClose: onClose,
      style: _objectSpread({}, animation),
      children: [/*#__PURE__*/_jsx(ModalOverlay, {
        onClick: onClose
      }), /*#__PURE__*/_jsx(ModalContentContainer, {
        children: /*#__PURE__*/_jsx(ModalContentPanel, {
          style: _objectSpread({
            width: modalWidth,
            height: modalHeight
          }, styles),
          children: children
        })
      })]
    })
  });
}

var StyledAnimatedModalContainer = /*#__PURE__*/_styled.div.withConfig({
  displayName: "modal-layout__StyledAnimatedModalContainer",
  componentId: "sc-14ak321-0"
})(["", ""], {
  "position": "fixed",
  "height": "100vh",
  "width": "100vw"
});

var StyledAnimatedModal = /*#__PURE__*/_styled(AnimatedModal).withConfig({
  displayName: "modal-layout__StyledAnimatedModal",
  componentId: "sc-14ak321-1"
})(["", ""], {
  "position": "fixed",
  "top": "0px",
  "zIndex": "150",
  "height": "100vh",
  "width": "100vw",
  "touchAction": "none"
});

var ModalOverlay = /*#__PURE__*/_styled.div.withConfig({
  displayName: "modal-layout__ModalOverlay",
  componentId: "sc-14ak321-2"
})(["", ""], {
  "position": "fixed",
  "zIndex": "50",
  "height": "100%",
  "width": "100%",
  "overflow": "hidden",
  "--tw-bg-opacity": "0.3",
  "backgroundColor": "rgb(209 213 219 / var(--tw-bg-opacity))"
});

var ModalContentContainer = /*#__PURE__*/_styled.div.withConfig({
  displayName: "modal-layout__ModalContentContainer",
  componentId: "sc-14ak321-3"
})(["", ""], {
  "display": "flex",
  "height": "100%",
  "width": "100%",
  "alignItems": "center",
  "justifyContent": "center",
  "borderTopLeftRadius": "1.5rem",
  "borderTopRightRadius": "1.5rem",
  "--tw-shadow": "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
  "--tw-shadow-colored": "0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color)",
  "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)"
});

var ModalContentPanel = /*#__PURE__*/_styled(Dialog.Panel).withConfig({
  displayName: "modal-layout__ModalContentPanel",
  componentId: "sc-14ak321-4"
})(["", ";"], {
  "left": "40vh",
  "zIndex": "60",
  "width": "100%",
  "borderRadius": "1rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
  "@media (min-width: 768px)": {
    "minWidth": "24rem",
    "maxWidth": "32rem"
  }
});

export default ModalLayout;